module.exports = __webpack_public_path__ + "static/media/instruction_ru.0abbcd2e.pdf";